import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import React from "react";
import Skeleton from "react-loading-skeleton";

type CountSummary = {
  count_1d: number;
  count_7d: number;
  count_30d: number;
  count_all: number;
};

function AdminTotalsTableRow(props: { name: string; counts?: CountSummary }) {
  return (
    <tr>
      <td>{props.name}</td>
      <td>{props.counts == null ? <Skeleton /> : props.counts.count_1d}</td>
      <td>{props.counts == null ? <Skeleton /> : props.counts.count_7d}</td>
      <td>{props.counts == null ? <Skeleton /> : props.counts.count_30d}</td>
      <td>{props.counts == null ? <Skeleton /> : props.counts.count_all}</td>
    </tr>
  );
}

export function AdminTotalsTable(props: { data?: any }) {
  const data = props.data ?? {};

  return (
    <Row>
      <Col md={{ span: 6, offset: 3 }}>
        <Table size="sm">
          <thead>
            <tr>
              <th>Totals</th>
              <th>1d</th>
              <th>7d</th>
              <th>30d</th>
              <th>all</th>
            </tr>
          </thead>
          <tbody>
            <AdminTotalsTableRow name="Inbounds" counts={data.inbound_count} />
            <AdminTotalsTableRow name="Downloads" counts={data.download_count} />
            <AdminTotalsTableRow name="Purchases" counts={data.purchase_count} />
            <AdminTotalsTableRow name="Activations" counts={data.activation_count} />
            <AdminTotalsTableRow name="Up chk uniq" counts={data.update_check_unique_count} />
            <AdminTotalsTableRow name="Update chk" counts={data.update_check_count} />
          </tbody>
        </Table>
      </Col>
    </Row>
  );
}
